import { Check } from "lucide-react";

export default function CheckList({ items, columns = 2 }) {
  const cols =
    columns === 3
      ? "sm:grid-cols-2 lg:grid-cols-3"
      : columns === 1
        ? "grid-cols-1"
        : "sm:grid-cols-2";
  return (
    <ul className={`grid grid-cols-1 ${cols} gap-x-6 gap-y-3`}>
      {items.map((item) => (
        <li key={item} className="flex items-start gap-3">
          <span className="flex items-center justify-center w-5 h-5 mt-0.5 shrink-0 bg-rust text-cream border border-charcoal">
            <Check className="w-3.5 h-3.5" strokeWidth={3} />
          </span>
          <span className="text-charcoal/85">{item}</span>
        </li>
      ))}
    </ul>
  );
}
